import { DivisionMembership } from 'src/store/modules/auth/v2Operations';

const DIVISIONS_STORAGE_KEY = 'sl-user-divisions';
export const CURRENT_DIVISION_KEY = 'sl-current-division-id';

/**
 * Save user's divisions to localStorage
 */
export const saveDivisions = (divisions: DivisionMembership[]): void => {
  try {
    localStorage.setItem(DIVISIONS_STORAGE_KEY, JSON.stringify(divisions));
  } catch (error) {
    console.error('Failed to save divisions to localStorage:', error);
  }
};

/**
 * Get user's divisions from localStorage
 */
export const getDivisions = (): DivisionMembership[] | null => {
  try {
    const stored = localStorage.getItem(DIVISIONS_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored) as DivisionMembership[];
    }
    return null;
  } catch (error) {
    console.error('Failed to get divisions from localStorage:', error);
    return null;
  }
};

/**
 * Clear divisions from localStorage (used on logout)
 */
export const clearDivisions = (): void => {
  try {
    localStorage.removeItem(DIVISIONS_STORAGE_KEY);
    localStorage.removeItem(CURRENT_DIVISION_KEY);
  } catch (error) {
    console.error('Failed to clear divisions from localStorage:', error);
  }
};

/**
 * Save current division ID to localStorage
 */
export const saveCurrentDivisionId = (divisionId: string): void => {
  try {
    localStorage.setItem(CURRENT_DIVISION_KEY, divisionId);
  } catch (error) {
    console.error('Failed to save current division ID to localStorage:', error);
  }
};

/**
 * Get current division ID from localStorage
 */
export const getCurrentDivisionId = (): string | null => {
  try {
    return localStorage.getItem(CURRENT_DIVISION_KEY);
  } catch (error) {
    console.error('Failed to get current division ID from localStorage:', error);
    return null;
  }
};

/**
 * Check if the current division has access to a specific app (via sl-user-memberships appAccess).
 */
export const currentDivisionHasAppAccess = (appName: string): boolean => {
  const divisionId = getCurrentDivisionId();
  const divisions = getDivisions();
  if (!divisionId || !divisions) return false;

  const current = divisions.find((d) => d.id === divisionId);
  const accessLevel = current?.appAccess?.[appName];
  return Boolean(accessLevel) && accessLevel !== 'blocked';
};

